import {
  OPEN_SHARE_MODAL,
  CLOSE_SHARE_MODAL,
  SET_LINK,
  REMOVE_LINK,
  COPY
} from "../actions/shareActions";

const initialState = {
  open: false,
  link: null,
  copied: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case OPEN_SHARE_MODAL:
      return {
        ...state,
        open: true,
        copied: false
      };
    case CLOSE_SHARE_MODAL:
      return {
        ...state,
        open: false,
        copied: false
      };
    case SET_LINK:
      return {
        ...state,
        link: action.link,
        copied: false
      };
    case REMOVE_LINK:
      return {
        ...state,
        link: null,
        copied: false
      };
    case COPY:
      return {
        ...state,
        copied: true
      };
    default:
      return state;
  }
};
